module.exports = __webpack_public_path__ + "static/media/m3tj54.59d9824b.png";